import { Button, Nav, Form, Row, Col } from "react-bootstrap";
import { Eraser, Search } from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";
import { useScreenHorizontal } from "../../../../Hook/useScreenPosition";
import { useGame } from "../../../../Hook/Financial/useGame";
import DateTimePicker from "../../../../Components/Form/DatePicker/DatePicker";

export default function AccountReceivableMenu({
    idClient,
    search,
    setSearch,
    reload,
}) {
    const { t } = useTranslation();
    const isMobile = useScreenHorizontal();

    const { games } = useGame({ idClient });

    return (
        <>
            <Nav className="mb-3">
                <Row className="w-100 flex align-middle">
                    <Col sm={isMobile ? 3 : 2}>
                        <span>
                            {t(
                                "financial.accounts-receivable.search.date-created-init"
                            )}
                        </span>
                        <DateTimePicker
                            position="left"
                            id="create_at_init"
                            value={search?.create_at_init || ""}
                            onChange={(value) => {
                                setSearch({
                                    ...search,
                                    create_at_init: value,
                                });
                            }}
                        />
                    </Col>
                    <Col sm={isMobile ? 3 : 2}>
                        <span>
                            {t(
                                "financial.accounts-receivable.search.date-created-end"
                            )}
                        </span>
                        <DateTimePicker
                            position="center"
                            id="create_at_end"
                            value={search?.create_at_end || ""}
                            onChange={(value) => {
                                setSearch({
                                    ...search,
                                    create_at_end: value,
                                });
                            }}
                        />
                    </Col>
                    <Col sm={isMobile ? 3 : 2}>
                        <span>
                            {t(
                                "financial.accounts-receivable.search.date-paid-init"
                            )}
                        </span>
                        <DateTimePicker
                            style={{ marginRight: 10 }}
                            position="center"
                            id="create_at_init"
                            value={search?.payment_date_init || ""}
                            onChange={(value) => {
                                setSearch({
                                    ...search,
                                    payment_date_init: value,
                                });
                            }}
                        />
                    </Col>
                    <Col sm={isMobile ? 3 : 2}>
                        <span>
                            {t(
                                "financial.accounts-receivable.search.date-paid-end"
                            )}
                        </span>
                        <DateTimePicker
                            position="center"
                            id="payment_date_end"
                            value={search?.payment_date_end || ""}
                            onChange={(value) => {
                                setSearch({
                                    ...search,
                                    payment_date_end: value,
                                });
                            }}
                        />
                    </Col>
                    <Col sm={isMobile ? 12 : 4} className="align-items-end">
                        <div className="d-flex">
                            <div className="flex-column w-50">
                                <span>
                                    {t(
                                        "financial.accounts-receivable.search.game.label"
                                    )}
                                </span>
                                <Form.Select
                                    id="search_game"
                                    value={search?.id_game || ""}
                                    onChange={(e) => {
                                        setSearch({
                                            ...search,
                                            id_game: parseInt(
                                                e.target.value,
                                                10
                                            ),
                                        });
                                    }}
                                >
                                    <option key="game-default-option" value="">
                                        {t(
                                            "financial.accounts-receivable.search.game.placeholder"
                                        )}
                                    </option>
                                    {games.map((game, index) => (
                                        <option
                                            key={`game-${index}-${game.id}`}
                                            value={game.id}
                                        >
                                            {game.description}
                                        </option>
                                    ))}
                                </Form.Select>
                            </div>

                            <div className="d-flex align-items-end gap-2 ms-3">
                                <Button
                                    variant="secondary"
                                    onClick={() => {
                                        setSearch({});
                                        reload();
                                    }}
                                >
                                    <Eraser className="me-2" />
                                    {t(
                                        "financial.accounts-receivable.search.button.clean"
                                    )}
                                </Button>
                                <Button
                                    variant="success"
                                    onClick={() => {
                                        reload();
                                    }}
                                >
                                    <Search className="me-2" />
                                    {t(
                                        "financial.accounts-receivable.search.button.search"
                                    )}
                                </Button>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Nav>
        </>
    );
}
